import FaqAdBlue from "./FaqAdBlue";

export default FaqAdBlue;
